import { ToolbarPolylineIcon } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS, ProductTypes } from '@editor/config/constants'
import { EditorTool, ToolbarCategory } from '@editor/interfaces/editor'
import { InspectionItemType, UserInfo } from '@editor/interfaces/interfaces'

import TargetColorCursor from './components/TargetColorCursor'
import ToolSettings from './components/ToolSettings'
import useEditor from './hooks/useEditor'
import useElementsPanel from './hooks/useElementsPanel'
import useMainCanvas from './hooks/useMainCanvas'

const Polyline: EditorTool = {
  key: EDITOR_TOOLS.POLYLINE,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    ((userProfile?.owned_products.includes(ProductTypes.Hatsuly) ||
      userProfile?.owned_products.includes(ProductTypes.Markly)) &&
      isAllowedToModify) ||
    false,
  toolbar: {
    icon: <ToolbarPolylineIcon width="50%" height="50%" />,
    label: EDITOR_TOOLS_LABELS.POLYLINE,
    category: ToolbarCategory.Generate,
  },
  components: {
    panel: ToolSettings,
    editor: [TargetColorCursor],
  },
  hooks: {
    useEditor,
    useMainCanvas,
    useElementsPanel,
  },
  config: {
    anchor: {
      notPlaceableOnObjects: true,
      useSolidMesh: true,
    },
    selectableInspectionItems: [InspectionItemType.PolylineLength],
  },
}

export default Polyline
